//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import putData from '../../testdata/put';
import {mapActions} from 'vuex';
import force from '../../common/forceLandscape';
export default {
  name: "topic",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        noSwiping: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          slideChange: () => {
            this.swiperindex = this.$refs.swiper.swiper.activeIndex;
          },
        },
      },
      swiperindex: 0,
      buildData: [],
      putData:[],
      zhengque:0,
      error:0
    }
  },
  methods: {
    ...mapActions(["changeTestStatus"]),
    shuffle() {
      this.putData.sort(() => {
        return Math.random() - 0.5;
      })
      return Promise.resolve('success');
    },
    check() {
      this.swiperindex++;
      var playerAnswer = this.buildData[this.swiperindex].data.slice(0, this.buildData[this.swiperindex].data.length / 2);
      var pAarr = [];
      playerAnswer.forEach((item, index) => {
        pAarr.push(item.id);
      })
      // pAarr=[1,2,3,4,5];  //测试用
      if(pAarr.toString() == this.buildData[this.swiperindex].answer.toString()){
        this.$vux.toast.text('回答正确','middle');
        this.zhengque++;
      }else{
        this.$vux.toast.text('回答错误','middle');
        this.error++;
      }
      if(this.error>=this.$store.state.maxerror.put){
        this.changeTestStatus({name:'put',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
          this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
        });
      }
      if(this.index>=this.buildData.length-1){
        this.changeTestStatus({name:'put',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
          this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
        });
      }
      // this.$refs.swiper.swiper.slideTo(this.swiperindex+1);
    }
  },
  mounted() {
    force();
  },
  created() {
    var routename=this.$route.name;
    var tixing=this.$store.state.tixing['lv'+this.$store.state.testLevel];
    var index=tixing.indexOf(routename);
    var title=`Test ${index+1} ${this.$store.state.title['lv'+this.$store.state.testLevel][index]}`;
    document.title=title;
    this.putData=putData['lv'+this.$store.state.testLevel];
    this.shuffle().then(_=>{
      for(let i=0;i<5;i++){
        var data=this.putData[i];
        // data.data.sort(()=>{
        //   return Math.random()-0.5;
        // })
        var space=[];
        for(let j=0;j<5;j++){   //生成5个空格
          var json={}
          json.id=0;
          json.pic=null;
          space.push(json);
        }
        data.data=space.concat(data.data);
        this.buildData.push(data);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/put/put.vue